import React from 'react';
import Bureau from 'components/Tvendo/Sale/DataMaster/Bureau/List.js';

export default function () {
  return <Bureau />;
}
